import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import EditIcon from '@material-ui/icons/Edit';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore';
import UnfoldLessIcon from '@material-ui/icons/UnfoldLess';

//Components
import AddQuestion from './addQuestionModal';


const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    bottom: theme.spacing(3),
    right: theme.spacing(3),
  },
  speedDial: {
      height: '20px',
      bottom: theme.spacing(3),
      right: theme.spacing(3),
  }
}));



export default function OpenIconSpeedDial({expand, handleExpand}) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [hidden, setHidden] = React.useState(false);
  const [modal, setModal] = useState(false);
  const [values, setValues] = useState({
      action: 'aq',
      choiceId: []

  })
  const actions = [
    { icon: <NoteAddIcon color="primary"/>, name: 'Add Question', act: 'new' },
    { icon: expand ? <UnfoldLessIcon color="primary"/> : <UnfoldMoreIcon color="primary"/>, name: `${expand ? 'Collapse' : 'Expand'}`, act: 'expand' },
  ];
 

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = (act) => {
    console.log(act);
    if(act === 'expand'){
        handleExpand(!expand)
    }
    if(act === 'new'){
        setModal(true);
    }

  };

  return (
    <div className={classes.root}>
        <AddQuestion modal={modal} handleModal={setModal} vals={values}/>
      <SpeedDial
        className={classes.speedDial}
        ariaLabel="SpeedDial openIcon example"
        hidden={hidden}
        icon={<SpeedDialIcon
            
            openIcon={<EditIcon fontSize="small" />} />}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
      >
        {actions.map((action) => (
          <SpeedDialAction
            className="m-1"
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            onClick={() => handleClick(action.act)}
          />
        ))}
      </SpeedDial>
    </div>
  );
}
